import React, { useState, useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import { Accordion, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import { RiUserStarFill, RiMoneyRupeeCircleFill } from "react-icons/ri";
import { IoLibrary } from "react-icons/io5";
import { HiDocumentReport } from "react-icons/hi";
import { IoIosArrowBack } from "react-icons/io";
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import { MdSchool, MdAdminPanelSettings, MdOutlineHelp, MdNotifications, MdNoteAlt, MdOutlineEmojiTransportation, MdOutlineWebAsset, MdCalculate, MdLocalLibrary, MdInventory, MdAssignmentReturn, MdShoppingCart } from "react-icons/md";
import { BsPeople, BsPersonCheck, BsBuilding, BsClipboardData, BsCardChecklist, BsBook, BsCalendar } from "react-icons/bs";

// Css
import '../leftNav/leftNav.css';

// Gadgets
import { Image } from 'react-bootstrap';

// Import Images
import appLogo from '../../../assets/images/common/logo.png';
import appLogoIcon from '../../../assets/images/common/appIcon.png';

const getInitialActiveKey = (pathname, isChildFutureAdmin) => {
    if (isChildFutureAdmin) {
        const isNotificationsPath =
            pathname.startsWith('/creategroups') || pathname.startsWith('/addcreategroups') ||
            pathname.startsWith('/sendnotifications') || pathname.startsWith('/addnotifications') ||
            pathname.startsWith('/sendfeenotifications') ||
            pathname.startsWith('/notifications') || pathname.startsWith('/addnewnotification') ||
            pathname.startsWith('/groupmembers') || pathname.startsWith('/addgroupmembers');

        const isPayrollPath =
            pathname.startsWith('/shift') || pathname.startsWith('/addshift') ||
            pathname.startsWith('/payrolldepartment') || pathname.startsWith('/addpayrolldepartment') ||
            pathname.startsWith('/leavemaster') || pathname.startsWith('/addnewleavemaster') ||
            pathname.startsWith('/employeeattendance') ||
            pathname.startsWith('/designation') || pathname.startsWith('/adddesignation') ||
            pathname.startsWith('/level') || pathname.startsWith('/addlevel') ||
            pathname.startsWith('/leave-entry') || pathname.startsWith('/addleaveentry') ||
            pathname.startsWith('/salarycomponent') || pathname.startsWith('/Addsalarycomponent') ||
            pathname.startsWith('/payrollschedule') ||
            pathname.startsWith('/viewpayroll') ||
            pathname.startsWith('/AddEmployeeDetails') || pathname.startsWith('/EmployeeDetails') ||
            pathname.startsWith('/salaryadvance') ||
            pathname.startsWith('/leaveapproval');

        const isInventoryPath =
            pathname.startsWith('/inventory') ||
            pathname.startsWith('/addinventory') ||
            pathname.startsWith('/inventorycategory') ||
            pathname.startsWith('/addinventorycategory') ||
            pathname.startsWith('/issuelist') ||
            pathname.startsWith('/issueinventory') ||
            pathname.startsWith('/inventorydashboard') ||
            pathname.startsWith('/purchaselist') ||
            pathname.startsWith('/purchaseentry');

        const isTransportPath =
            pathname.startsWith('/routes') || pathname.startsWith('/addbusroutes') ||
            pathname.startsWith('/buses') || pathname.startsWith('/addbuses') ||
            pathname.startsWith('/location') || pathname.startsWith('/addlocation') ||
            pathname.startsWith('/stops') || pathname.startsWith('/addstops') ||
            pathname.startsWith('/busassignment') || pathname.startsWith('/addbusassignment') ||
            pathname.startsWith('/tripattendance');

        const isFinancePath =
            pathname.startsWith('/finance') ||
            [
                '/finance/groups', '/finance/groups/add',
                '/finance/accounts', '/finance/accounts/add',
                '/finance/subaccounts', '/finance/subaccounts/add',
                '/finance/gste', '/finance/gste/add',
                '/finance/gst/mapping', '/finance/gst/mapping/add',
                '/finance/services', '/finance/services/add',
                '/finance/tds', '/finance/tds/add',
                '/finance/tcs', '/finance/tcs/add',
                '/finance/budget', '/finance/budget/add',
                '/finance/vouchers', '/finance/vouchers/add',
                '/finance/voucher-approvals', '/finance/voucher-approvals/add',
                '/finance/accounthead', '/finance/addaccounthead', 'finance/transaction', 'finance/transaction/add',
                'finance/subledger', '/finance/addsubledger'
            ].some(p => pathname.startsWith(p));

        const isOrgVisitsPath = pathname.startsWith('/orgvisits') || pathname.startsWith('/addorgvisit');

        const isAdminPath =
            pathname.startsWith('/users') || pathname.startsWith('/usersadd') ||
            pathname.startsWith('/schoolmaster') || pathname.startsWith('/addNewSchool') ||
            pathname.startsWith('/roles') || pathname.startsWith('/AddRoles') ||
            pathname.startsWith('/departments') || pathname.startsWith('/AddDepartments') ||
            pathname.startsWith('/dashboard') ||
            pathname.startsWith('/principaldashboard') ||
            pathname.startsWith('/schoolcalendar') || pathname.startsWith('/addevent') ||
            pathname.startsWith('/gallery') ||
            pathname.startsWith('/addgallery');

        if (isAdminPath) {
            return "1";
        } else if (isPayrollPath) {
            return "10";
        } else if (isFinancePath) {
            return "8";
        } else if (isInventoryPath) {
            return "14";
        } else if (isNotificationsPath) {
            return "13";
        } else if (isTransportPath) {
            return "7";
        } else if (isOrgVisitsPath) {
            return "orgvisits";
        } else {
            return "10";
        }
    }

    // Default non-Child Future Admin check
    if (
        pathname.startsWith('/users') || pathname.startsWith('/usersadd') ||
        pathname.startsWith('/schoolmaster') || pathname.startsWith('/addNewSchool') ||
        pathname.startsWith('/roles') || pathname.startsWith('/AddRoles') ||
        pathname.startsWith('/departments') || pathname.startsWith('/AddDepartments') ||
        pathname.startsWith('/dashboard') ||
        pathname.startsWith('/principaldashboard') ||
        pathname.startsWith('/schoolcalendar') || pathname.startsWith('/addevent') ||
        pathname.startsWith('/gallery') ||
        pathname.startsWith('/addgallery')
    ) {
        return "1"; // Admin
    }

    if (
        pathname.startsWith('/classes') || pathname.startsWith('/addnewclass') ||
        pathname.startsWith('/subjects') || pathname.startsWith('/addsubject') ||
        pathname.startsWith('/students') || pathname.startsWith('/addstudent') ||
        pathname.startsWith('/viewstudents') ||
        pathname.startsWith('/studentacademicyear') ||
        pathname.startsWith('/AddStudentAcademic') ||
        pathname.startsWith('/sections') ||
        pathname.startsWith('/AddNewSections') ||
        pathname.startsWith('/teachersubjectmap') ||
        pathname.startsWith('/addteachersubjectmap') ||
        pathname.startsWith('/studentattendance') ||
        pathname.startsWith('/addstudentattendance') ||
        pathname.startsWith('/homework') ||
        pathname.startsWith('/addhomework') ||
        pathname.startsWith('/periods') ||
        pathname.startsWith('/addperiods') ||
        pathname.startsWith('/syllabus') ||
        pathname.startsWith('/addsyllabus') ||
        pathname.startsWith('/timetable') ||
        pathname.startsWith('/addtimetable') ||
        pathname.startsWith('/academicyear') ||
        pathname.startsWith('/category') ||
        pathname.startsWith('/addcategory') ||
        pathname.startsWith('/promotestudents') ||
        pathname.startsWith('/approvals') ||
        pathname.startsWith('/teachertimetable') ||
        pathname.startsWith('/assignlanguages')
    ) {
        return "2"; // SMS
    }

    if (
        pathname.startsWith('/creategroups') || pathname.startsWith('/addcreategroups') ||
        pathname.startsWith('/sendnotifications') || pathname.startsWith('/addnotifications') ||
        pathname.startsWith('/sendfeenotifications') ||
        pathname.startsWith('/notifications') || pathname.startsWith('/addnewnotification') ||
        pathname.startsWith('/groupmembers') || pathname.startsWith('/addgroupmembers')
    ) {
        return "13";
    }

    if (
        pathname.startsWith('/feeitems') || pathname.startsWith('/addfeeitems') ||
        pathname.startsWith('/feeitemslist') || pathname.startsWith('/addfeeitemslist') ||
        pathname.startsWith('/feediscount') || pathname.startsWith('/addfeediscount') ||
        pathname.startsWith('/feeitemschedule') || pathname.startsWith('/addfeeitemschedule') ||
        pathname.startsWith('/feeitemschedule1') || pathname.startsWith('/addfeeitemschedule1') ||
        pathname.startsWith('/feeschedule') || pathname.startsWith('/addfeeschedule') ||
        pathname.startsWith('/feesstudentsschedule') || pathname.startsWith('/addfeesstudentsschedule') ||
        pathname.startsWith('/feereceipts') || pathname.startsWith('/addfeereceipts') ||
        pathname.startsWith('/feecategory') || pathname.startsWith('/addfeecategory')
    ) {
        return "3";
    }

    if (
        pathname.startsWith('/grades') || pathname.startsWith('/addgrades') ||
        pathname.startsWith('/result') || pathname.startsWith('/addresult') ||
        pathname.startsWith('/examschedule') || pathname.startsWith('/addexamschedule') ||
        pathname.startsWith('/exam') || pathname.startsWith('/addexam') ||
        pathname.startsWith('/bulkaddresult') || pathname.startsWith("/publishresults")
    ) {
        return "5";
    }

    if (
        pathname.startsWith('/historyreports') ||
        pathname.startsWith('/dailyattendancereport') ||
        pathname.startsWith('/wiseattendancereport') ||
        pathname.startsWith('/admissionreport') ||
        pathname.startsWith('/typereport') ||
        pathname.startsWith('/schoolstrength') ||
        pathname.startsWith('/classwisestudentsreport') ||
        pathname.startsWith('/classwiseteachersreport') ||
        pathname.startsWith('/classwisetechersubject') ||
        pathname.startsWith('/siblings') ||
        pathname.startsWith('/homeworkreport') ||
        pathname.startsWith('/usersreport') ||
        pathname.startsWith('/monitoringreport') ||
        pathname.startsWith('/examschedulestatusreport') ||
        pathname.startsWith('/feereport') ||
        pathname.startsWith('/feereceiptprintreport') ||
        pathname.startsWith('/studentdiscountreport') ||
        pathname.startsWith('/employeeattendancereport') ||
        pathname.startsWith('/latedays') ||
        pathname.startsWith('/payrollreport') ||
        pathname.startsWith('/salaryreport') ||
        pathname.startsWith('/idgenerator') ||
        pathname.startsWith('/studycertificate')
    ) {
        return "reports";
    }

    if (
        pathname.startsWith('/routes') || pathname.startsWith('/addbusroutes') ||
        pathname.startsWith('/buses') || pathname.startsWith('/addbuses') ||
        pathname.startsWith('/location') || pathname.startsWith('/addlocation') ||
        pathname.startsWith('/stops') || pathname.startsWith('/addstops') ||
        pathname.startsWith('/busassignment') || pathname.startsWith('/addbusassignment') ||
        pathname.startsWith('/tripattendance')
    ) {
        return "7";
    }

    if (
        pathname.startsWith('/shift') || pathname.startsWith('/addshift') ||
        pathname.startsWith('/payrolldepartment') || pathname.startsWith('/addpayrolldepartment') ||
        pathname.startsWith('/leavemaster') || pathname.startsWith('/addnewleavemaster') ||
        pathname.startsWith('/employeeattendance') ||
        pathname.startsWith('/designation') || pathname.startsWith('/adddesignation') ||
        pathname.startsWith('/level') || pathname.startsWith('/addlevel') ||
        pathname.startsWith('/leave-entry') || pathname.startsWith('/addleaveentry') ||
        pathname.startsWith('/salarycomponent') || pathname.startsWith('/Addsalarycomponent') ||
        pathname.startsWith('/payrollschedule') ||
        pathname.startsWith('/viewpayroll') ||
        pathname.startsWith('/AddEmployeeDetails') || pathname.startsWith('/EmployeeDetails') ||
        pathname.startsWith('/salaryadvance') ||
        pathname.startsWith('/leaveapproval')
    ) {
        return "10";
    }

    if (
        pathname.startsWith('/finance') ||
        [
            '/finance/groups', '/finance/groups/add',
            '/finance/accounts', '/finance/accounts/add',
            '/finance/subaccounts', '/finance/subaccounts/add',
            '/finance/gste', '/finance/gste/add',
            '/finance/gst/mapping', '/finance/gst/mapping/add',
            '/finance/services', '/finance/services/add',
            '/finance/tds', '/finance/tds/add',
            '/finance/tcs', '/finance/tcs/add',
            '/finance/budget', '/finance/budget/add',
            '/finance/vouchers', '/finance/vouchers/add',
            '/finance/voucher-approvals', '/finance/voucher-approvals/add',
            '/finance/accounthead', '/finance/addaccounthead', 'finance/transaction', 'finance/transaction/add',
            'finance/subledger', '/finance/addsubledger'
        ].some(p => pathname.startsWith(p))
    ) {
        return "8";
    }

    if (
        pathname.startsWith('/inventory') ||
        pathname.startsWith('/addinventory') ||
        pathname.startsWith('/inventorycategory') ||
        pathname.startsWith('/addinventorycategory') ||
        pathname.startsWith('/issuelist') ||
        pathname.startsWith('/issueinventory') ||
        pathname.startsWith('/inventorydashboard') ||
        pathname.startsWith('/purchaselist') ||
        pathname.startsWith('/purchaseentry')
    ) {
        return "14";
    }

    if (
        pathname.startsWith('/orgvisits') ||
        pathname.startsWith('/addorgvisit')
    ) {
        return "orgvisits";
    }

    return null;
};

const getInitialReportActiveKey = (pathname) => {
    if (
        pathname.startsWith('/historyreports') ||
        pathname.startsWith('/dailyattendancereport') ||
        pathname.startsWith('/wiseattendancereport') ||
        pathname.startsWith('/admissionreport') ||
        pathname.startsWith('/typereport') ||
        pathname.startsWith('/schoolstrength') ||
        pathname.startsWith('/classwisestudentsreport') ||
        pathname.startsWith('/classwiseteachersreport') ||
        pathname.startsWith('/classwisetechersubject') ||
        pathname.startsWith('/siblings') ||
        pathname.startsWith('/homeworkreport') ||
        pathname.startsWith('/usersreport') ||
        pathname.startsWith('/monitoringreport') ||
        pathname.startsWith('/examschedulestatusreport')
    ) {
        return "smsReports";
    }
    if (
        pathname.startsWith('/feereport') ||
        pathname.startsWith('/feereceiptprintreport') ||
        pathname.startsWith('/studentdiscountreport')
    ) {
        return "feeReports";
    }
    if (
        pathname.startsWith('/employeeattendancereport') ||
        pathname.startsWith('/latedays') ||
        pathname.startsWith('/payrollreport') ||
        pathname.startsWith('/salaryreport')
    ) {
        return "hrReports";
    }
    if (
        pathname.startsWith('/idgenerator') ||
        pathname.startsWith('/studycertificate')
    ) {
        return "Generators";
    }
    return null;
};

const LeftNav = () => {
    const location = useLocation();
    const userData = sessionStorage.getItem('user');
    const userObj = JSON.parse(userData || '{}');
    const isChildFutureAdmin = userObj?.role_name?.trim()?.toLowerCase() === 'child future admin';

    const [activeKey, setActiveKey] = useState(() => getInitialActiveKey(location.pathname, isChildFutureAdmin));          // top-level accordions
    const [reportActiveKey, setReportActiveKey] = useState(() => getInitialReportActiveKey(location.pathname)); // inner accordions under Reports
    const [isOpen, setIsOpen] = useState(false);

    const toggleLeftNav = () => {
        setIsOpen(!isOpen);
    };
    const navigate = useNavigate();

    useEffect(() => {
        setActiveKey(getInitialActiveKey(location.pathname, isChildFutureAdmin));
        setReportActiveKey(getInitialReportActiveKey(location.pathname));
    }, [location.pathname, isChildFutureAdmin]);

    const handleAccordionToggle = (key) => {
        setActiveKey(activeKey === key ? null : key);
    };

    const handleReportAccordionToggle = (key) => {
        setReportActiveKey(reportActiveKey === key ? null : key);
    };

    return (
        <div className={`leftNav ${isOpen ? "closeNav" : ""}`}>
            <div className='leftNavTopPart'>
                <div className='logoPart'>
                    {(userObj.role_name === 'Director' || userObj.role_name === 'Principal' || userObj.role_name === 'Admin') && (
                        <NavLink to="/principaldashboard">
                            <Image src={appLogo} alt="Account Background" className='appLogo' />
                            <Image src={appLogoIcon} alt="Account Background" className='appLogoIcon' />
                        </NavLink>
                    )}

                    {(userObj.role_name === 'Teacher') && (
                        <NavLink to="/dashboard">
                            <Image src={appLogo} alt="Account Background" className='appLogo' />
                            <Image src={appLogoIcon} alt="Account Background" className='appLogoIcon' />
                        </NavLink>
                    )}

                    {isChildFutureAdmin && (
                        <NavLink to="/finance/reports">
                            <Image src={appLogo} alt="Account Background" className='appLogo' />
                            <Image src={appLogoIcon} alt="Account Background" className='appLogoIcon' />
                        </NavLink>
                    )}

                    {(userObj.role_name !== 'Director' &&
                        userObj.role_name !== 'Principal' &&
                        userObj.role_name !== 'Admin' &&
                        userObj.role_name !== 'Teacher' &&
                        !isChildFutureAdmin) && (
                            <>
                                <Image src={appLogo} alt="Account Background" className='appLogo' />
                                <Image src={appLogoIcon} alt="Account Background" className='appLogoIcon' />
                            </>
                        )}
                </div>

                <div className='toggleNavBtnPart'>
                    <Button variant="primary" className='toggleNavBtn' onClick={toggleLeftNav}>
                        <IoIosArrowBack />
                    </Button>
                </div>
            </div>
            <Nav variant="pills" activeKey={activeKey}>

                {/* SMS (Student Management System) */}
                {!isChildFutureAdmin && (
                <Accordion activeKey={activeKey}>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header onClick={() => handleAccordionToggle("2")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Student Management System</Tooltip>}>
                                <span className='leftNavIcon'><MdSchool /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>SMS</span>
                        </Accordion.Header>
                        <Accordion.Collapse eventKey="2">
                            <Nav className="flex-column">
                                <NavLink to="/academicyear" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/academicyear') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Academic</Tooltip>}>
                                        <span className='leftNavIcon'><BsCalendar /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Academic</span>
                                </NavLink>

                                <NavLink to="/category" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addcategory') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Category</Tooltip>}>
                                        <span className='leftNavIcon'><BsBook /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Category</span>
                                </NavLink>

                                <NavLink to="/classes" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addnewclass') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Classes</Tooltip>}>
                                        <span className='leftNavIcon'><BsCardChecklist /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Classes</span>
                                </NavLink>

                                <NavLink to="/subjects" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addsubject') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Subjects</Tooltip>}>
                                        <span className='leftNavIcon'><BsBook /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Subjects</span>
                                </NavLink>

                                <NavLink
                                    to="/students"
                                    className={({ isActive }) =>
                                        isActive || location.pathname === "/addstudent" || location.pathname === "/viewstudents"
                                            ? "nav-link active"
                                            : "nav-link"
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Students</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Students</span>
                                </NavLink>

                                <NavLink to="/periods" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addperiods') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Periods</Tooltip>}>
                                        <span className='leftNavIcon'><BsBook /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Periods</span>
                                </NavLink>

                                <NavLink to="/timetable" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addtimetable') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Time Table</Tooltip>}>
                                        <span className='leftNavIcon'><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Time Table</span>
                                </NavLink>

                                <NavLink to="/teachertimetable" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/teachertimetable') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Teacher Timetable</Tooltip>}>
                                        <span className='leftNavIcon'><BsBook /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Teacher Timetable</span>
                                </NavLink>

                                <NavLink to="/studentattendance" className={({ isActive }) =>
                                    isActive || location.pathname === '/addstudentattendance' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Attendance</Tooltip>}>
                                        <span className='leftNavIcon'><BsClipboardData /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Attendance</span>
                                </NavLink>

                                <NavLink to="/homework/homeworklist" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addhomework') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Homework</Tooltip>}>
                                        <span className='leftNavIcon'><BsBook /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Homework</span>
                                </NavLink>

                                <NavLink to="/syllabus" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addsyllabus') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Syllabus Planning</Tooltip>}>
                                        <span className='leftNavIcon'><BsBook /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Syllabus Planning</span>
                                </NavLink>

                                <NavLink to="/assignlanguages" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/assignlanguages') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Assign Languages</Tooltip>}>
                                        <span className='leftNavIcon'><BsBook /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Assign Languages</span>
                                </NavLink>

                                <NavLink to="/approvals" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/approvals') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Approvals</Tooltip>}>
                                        <span className='leftNavIcon'><BsBook /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Approvals</span>
                                </NavLink>

                                <NavLink to="/promotestudents" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/promotestudents') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Promote Students</Tooltip>}>
                                        <span className='leftNavIcon'><BsBook /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Promote Students</span>
                                </NavLink>
                            </Nav>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </Accordion>
                )}

                {/* Fee Management */}
                {!isChildFutureAdmin && (
                <Accordion activeKey={activeKey}>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header onClick={() => handleAccordionToggle("3")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Fee Management</Tooltip>}>
                                <span className='leftNavIcon'><RiMoneyRupeeCircleFill /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Fee Management</span>
                        </Accordion.Header>
                        <Accordion.Collapse eventKey="3">
                            <Nav className="flex-column">
                                <NavLink to="/feecategory" className={({ isActive }) =>
                                    isActive || location.pathname === '/addfeecategory' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Fee Category</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Fee Category</span>
                                </NavLink>

                                <NavLink to="/feeitemslist" className={({ isActive }) =>
                                    isActive || location.pathname === '/addfeeitemslist' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Fee Items List</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Fee Items List</span>
                                </NavLink>

                                <NavLink to="/feeitems" className={({ isActive }) =>
                                    isActive || location.pathname === '/addfeeitems' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Fees Items Amount</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Fees Items Amount</span>
                                </NavLink>

                                <NavLink to="/feescheduletype" className={({ isActive }) =>
                                    isActive || location.pathname === '/addfeescheduletype' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Fee Schedule Type</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Fee Schedule Type</span>
                                </NavLink>

                                <NavLink to="/feeschedule" className={({ isActive }) =>
                                    isActive || location.pathname === '/addfeeschedule' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Fees Schedule</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Fees Schedule</span>
                                </NavLink>

                                <NavLink to="/feeitemschedule" className={({ isActive }) =>
                                    isActive || location.pathname === '/addfeeitemschedule' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Fees Item Schedule</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Fees Item Schedule</span>
                                </NavLink>

                                <NavLink to="/feesstudentsschedule" className={({ isActive }) =>
                                    isActive || location.pathname === '/addfeesstudentsschedule' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Fees Discount</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Fees Discount</span>
                                </NavLink>

                                <NavLink to="/feereceipts" className={({ isActive }) =>
                                    isActive || location.pathname === '/addfeereceipts' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Fee Receipts</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Fee Receipts</span>
                                </NavLink>
                            </Nav>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </Accordion>
                )}

                {/* Exam Module */}
                {!isChildFutureAdmin && (
                <Accordion activeKey={activeKey}>
                    <Accordion.Item eventKey="5">
                        <Accordion.Header onClick={() => handleAccordionToggle("5")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Exam Module</Tooltip>}>
                                <span className='leftNavIcon'><MdNoteAlt /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Exam Module</span>
                        </Accordion.Header>
                        <Accordion.Collapse eventKey="5">
                            <Nav className="flex-column">
                                <NavLink
                                    to="/exam"
                                    className={({ isActive }) =>
                                        isActive || location.pathname === "/addexam" ? "nav-link active" : "nav-link"
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Exam Master</Tooltip>}>
                                        <span className="leftNavIcon"><BsCalendar /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Exam Master</span>
                                </NavLink>

                                <NavLink to="/grades"
                                    className={({ isActive }) =>
                                        isActive || location.pathname === "/addgrades" ? "nav-link active" : "nav-link"
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Grades</Tooltip>}>
                                        <span className='leftNavIcon'><BsClipboardData /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Grades</span>
                                </NavLink>

                                <NavLink to="/examschedule" className={({ isActive }) =>
                                    isActive || location.pathname === "/addexamschedule" ? "nav-link active" : "nav-link"
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Exam Schedule</Tooltip>}>
                                        <span className='leftNavIcon'><BsCalendar /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Exam Schedule</span>
                                </NavLink>

                                <NavLink
                                    to="/result"
                                    className={({ isActive }) =>
                                        isActive || location.pathname === "/addresult" || location.pathname === "/bulkaddresult"
                                            ? "nav-link active"
                                            : "nav-link"
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Exam Results</Tooltip>}>
                                        <span className="leftNavIcon"><BsClipboardData /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Exam Results</span>
                                </NavLink>

                                {userObj?.role_name === "Admin" && (
                                    <NavLink
                                        to="/publishresults"
                                        className={({ isActive }) =>
                                            isActive || location.pathname === "/publishresults"
                                                ? "nav-link active"
                                                : "nav-link"
                                        }
                                    >
                                        <OverlayTrigger placement="right" overlay={<Tooltip>Publish Results</Tooltip>}>
                                            <span className="leftNavIcon"><BsClipboardData /></span>
                                        </OverlayTrigger>
                                        <span className="leftNavIconLabel">Publish Results</span>
                                    </NavLink>
                                )}
                            </Nav>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </Accordion>
                )}

                {/* Notifications */}
                <Accordion activeKey={activeKey} style={{ order: isChildFutureAdmin ? 4 : undefined }}>
                    <Accordion.Item eventKey="13">
                        <Accordion.Header onClick={() => handleAccordionToggle("13")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Notifications</Tooltip>}>
                                <span className='leftNavIcon'><MdNotifications /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Notifications</span>
                        </Accordion.Header>
                        <Accordion.Collapse eventKey="13">
                            <Nav className="flex-column">
                                <NavLink to="/creategroups" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addcreategroups') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Create Groups</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Create Groups</span>
                                </NavLink>

                                <NavLink to="/groupmembers" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addgroupmembers') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Group Members</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Group Members</span>
                                </NavLink>

                                <NavLink to="/notifications" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addnewnotification') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Create Notifications</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Create Notifications</span>
                                </NavLink>

                                <NavLink to="/sendnotifications" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addnotifications') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Send Notification</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Send Notification</span>
                                </NavLink>

                                <NavLink to="/sendfeenotifications" className={({ isActive }) =>
                                    isActive ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Send Fee Notifications</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Send Fee Notifications</span>
                                </NavLink>
                            </Nav>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </Accordion>

                {/* Payroll & HR (Masters/Transactions) */}
                <Accordion activeKey={activeKey} style={{ order: isChildFutureAdmin ? 1 : undefined }}>
                    <Accordion.Item eventKey="10">
                        <Accordion.Header onClick={() => handleAccordionToggle("10")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Payroll & HR</Tooltip>}>
                                <span className='leftNavIcon'><MdCalculate /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Payroll & HR</span>
                        </Accordion.Header>
                        <Accordion.Collapse eventKey="10">
                            <Nav className="flex-column">
                                <NavLink
                                    to="/EmployeeDetails"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/AddEmployeeDetails') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Employee Details</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Employee Details</span>
                                </NavLink>

                                <NavLink
                                    to="/shift"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/shift') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Shift Master</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Shift Master</span>
                                </NavLink>

                                <NavLink to="/designation" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/adddesignation') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Designation Master</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Designation Master</span>
                                </NavLink>

                                <NavLink to="/level" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addlevel') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Level Master</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Level Master</span>
                                </NavLink>

                                <NavLink
                                    to="/leavemaster"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/addnewleavemaster') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Leave Master</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Leave Master</span>
                                </NavLink>

                                <NavLink
                                    to="/leave-entry"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/addleaveentry') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Apply Leave</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Apply Leave</span>
                                </NavLink>

                                <NavLink
                                    to="/employeeattendance"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/employeeattendance') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Employee Attendance</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Employee Attendance</span>
                                </NavLink>

                                <NavLink
                                    to="/salarycomponent"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/Addsalarycomponent') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Salary Component</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Salary Component</span>
                                </NavLink>

                                <NavLink
                                    to="/payrollschedule"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/payrollschedule') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Payroll Schedule</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Payroll Schedule</span>
                                </NavLink>

                                <NavLink
                                    to="/salaryadvance"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/salaryadvance') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Salary Advance</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Salary Advance</span>
                                </NavLink>

                                <NavLink
                                    to="/viewpayroll"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/viewpayroll') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>View/Run Payroll</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">View/Run Payroll</span>
                                </NavLink>

                                <NavLink
                                    to="/leaveapproval"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/leaveapproval') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Leave Approval</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Leave Approval</span>
                                </NavLink>
                            </Nav>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </Accordion>

                {/* Inventory Management */}
                <Accordion activeKey={activeKey} style={{ order: isChildFutureAdmin ? 3 : undefined }}>
                    <Accordion.Item eventKey="14">
                        <Accordion.Header onClick={() => handleAccordionToggle("14")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Inventory Management</Tooltip>}>
                                <span className='leftNavIcon'><MdOutlineWebAsset /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Inventory</span>
                        </Accordion.Header>
                        <Accordion.Collapse eventKey="14">
                            <Nav className="flex-column">
                                <NavLink to="/inventorydashboard" className={({ isActive }) =>
                                    isActive ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Inventory Dashboard</Tooltip>}>
                                        <span className='leftNavIcon'><MdInventory /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Dashboard</span>
                                </NavLink>

                                <NavLink to="/inventorycategory" className={({ isActive }) =>
                                    isActive || location.pathname === '/addinventorycategory' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Inventory Category</Tooltip>}>
                                        <span className='leftNavIcon'><BsCardChecklist /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Categories</span>
                                </NavLink>

                                <NavLink to="/inventorylist" className={({ isActive }) =>
                                    isActive || location.pathname === '/addinventoryitem' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Inventory List</Tooltip>}>
                                        <span className='leftNavIcon'><BsClipboardData /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Items</span>
                                </NavLink>



                                <NavLink to="/purchaselist" className={({ isActive }) =>
                                    isActive || location.pathname === '/purchaseentry' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Purchases</Tooltip>}>
                                        <span className='leftNavIcon'><MdShoppingCart /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Purchases</span>
                                </NavLink>

                                <NavLink to="/issuelist" className={({ isActive }) =>
                                    isActive || location.pathname === '/issueinventory' ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Issue Item</Tooltip>}>
                                        <span className='leftNavIcon'><BsClipboardData /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Issue Item</span>
                                </NavLink>
                            </Nav>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </Accordion>

                {/* Admin */}
                <Accordion activeKey={activeKey} style={{ order: isChildFutureAdmin ? 7 : undefined }}>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header onClick={() => handleAccordionToggle("1")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Admin</Tooltip>}>
                                <span className='leftNavIcon'><MdAdminPanelSettings /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Admin</span>
                        </Accordion.Header>
                        <Accordion.Collapse eventKey="1">
                            <Nav className="flex-column">
                                {(userObj.role_name === 'Director' || userObj.role_name === 'Principal' || userObj.role_name === 'Admin') && (
                                    <NavLink
                                        to="/principaldashboard"
                                        className={({ isActive }) =>
                                            isActive || location.pathname.startsWith('/principaldashboard') ? 'nav-link active' : 'nav-link'
                                        }
                                    >
                                        <OverlayTrigger placement="right" overlay={<Tooltip>Principal Dashboard</Tooltip>}>
                                            <span className='leftNavIcon'><BsPeople /></span>
                                        </OverlayTrigger>
                                        <span className='leftNavIconLabel'>Principal Dashboard</span>
                                    </NavLink>
                                )}

                                {(userObj.role_name === 'Teacher' || userObj.role_name === 'Admin') && (
                                    <NavLink
                                        to="/dashboard"
                                        className={({ isActive }) =>
                                            isActive || location.pathname.startsWith('/dashboard') ? 'nav-link active' : 'nav-link'
                                        }
                                    >
                                        <OverlayTrigger placement="right" overlay={<Tooltip>Dashboard</Tooltip>}>
                                            <span className='leftNavIcon'><BsPeople /></span>
                                        </OverlayTrigger>
                                        <span className='leftNavIconLabel'>Teacher Dashboard</span>
                                    </NavLink>
                                )}

                                <NavLink
                                    to="/users"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/usersadd') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Users</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Users</span>
                                </NavLink>

                                <NavLink
                                    to="/schoolmaster"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/addNewSchool') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>School Master</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>School Master</span>
                                </NavLink>

                                <NavLink to="/roles" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/AddRoles') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Roles</Tooltip>}>
                                        <span className='leftNavIcon'><BsPersonCheck /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Roles</span>
                                </NavLink>

                                <NavLink to="/departments" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/AddDepartments') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Departments</Tooltip>}>
                                        <span className='leftNavIcon'><BsBuilding /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Departments</span>
                                </NavLink>

                                <NavLink to="/schoolcalendar" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addevent') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>School Calendar</Tooltip>}>
                                        <span className='leftNavIcon'><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>School Calendar</span>
                                </NavLink>

                                <NavLink
                                    to="/gallery"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/addgallery') ? 'nav-link active' : 'nav-link'
                                    }
                                >
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Gallery</Tooltip>}>
                                        <span className='leftNavIcon'><BsPeople /></span>
                                    </OverlayTrigger>
                                    <span className='leftNavIconLabel'>Gallery</span>
                                </NavLink>
                            </Nav>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </Accordion>

                {/* Help Desk */}
                {!isChildFutureAdmin && (
                <Accordion activeKey={activeKey}>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header onClick={() => handleAccordionToggle("4")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Help Desk</Tooltip>}>
                                <span className='leftNavIcon'><MdOutlineHelp /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Help Desk</span>
                        </Accordion.Header>
                    </Accordion.Item>
                </Accordion>
                )}

                {/* Reports - with 3 inner accordions */}
                {!isChildFutureAdmin && (
                <Accordion activeKey={activeKey}>
                    <Accordion.Item eventKey="reports">
                        <Accordion.Header onClick={() => handleAccordionToggle("reports")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Reports</Tooltip>}>
                                <span className='leftNavIcon'><HiDocumentReport /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Reports</span>
                        </Accordion.Header>
                        <Accordion.Collapse eventKey="reports">
                            <div className="reports-inner">
                                <Accordion activeKey={reportActiveKey}>
                                    {/* SMS Reports */}
                                    <Accordion.Item eventKey="smsReports">
                                        <Accordion.Header onClick={() => handleReportAccordionToggle("smsReports")}>
                                            <span className='leftNavIconLabel'>SMS Reports</span>
                                        </Accordion.Header>
                                        <Accordion.Collapse eventKey="smsReports">
                                            <Nav className="flex-column">
                                                <NavLink to="/historyreports" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/historyreports') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className="leftNavIcon"><RiUserStarFill /></span>
                                                    <span className="leftNavIconLabel">Students 360</span>
                                                </NavLink>

                                                <NavLink to="/admissionreport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/admissionreport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className="leftNavIcon"><RiUserStarFill /></span>
                                                    <span className="leftNavIconLabel">Admission Report</span>
                                                </NavLink>

                                                <NavLink to="/typereport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/typereport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className="leftNavIcon"><RiUserStarFill /></span>
                                                    <span className="leftNavIconLabel">Student Attendance Type Report</span>
                                                </NavLink>

                                                <NavLink to="/dailyattendancereport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/dailyattendancereport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className="leftNavIcon"><RiUserStarFill /></span>
                                                    <span className="leftNavIconLabel">Daily Attendance Report</span>
                                                </NavLink>

                                                <NavLink to="/wiseattendancereport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/wiseattendancereport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className="leftNavIcon"><RiUserStarFill /></span>
                                                    <span className="leftNavIconLabel">Day Wise Attendance Report</span>
                                                </NavLink>

                                                <NavLink to="/schoolstrength" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/schoolstrength') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsPersonCheck /></span>
                                                    <span className='leftNavIconLabel'>School Strength</span>
                                                </NavLink>

                                                <NavLink to="/classwisestudentsreport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/classwisestudentsreport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsPersonCheck /></span>
                                                    <span className='leftNavIconLabel'>Classwise Students</span>
                                                </NavLink>

                                                <NavLink to="/classwiseteachersreport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/classwiseteachersreport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsPersonCheck /></span>
                                                    <span className='leftNavIconLabel'>Classwise Teachers</span>
                                                </NavLink>

                                                <NavLink to="/classwisetechersubject" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/classwisetechersubject') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsPersonCheck /></span>
                                                    <span className='leftNavIconLabel'>Classwise Teacher and Subject</span>
                                                </NavLink>

                                                <NavLink to="/siblings" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/siblings') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsBook /></span>
                                                    <span className='leftNavIconLabel'>Siblings</span>
                                                </NavLink>

                                                <NavLink to="/homeworkreport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/homeworkreport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsBook /></span>
                                                    <span className='leftNavIconLabel'>Homework Report</span>
                                                </NavLink>

                                                <NavLink to="/usersreport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/usersreport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsBook /></span>
                                                    <span className='leftNavIconLabel'>Active Users</span>
                                                </NavLink>

                                                <NavLink to="/monitoringreport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/monitoringreport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsBook /></span>
                                                    <span className='leftNavIconLabel'>Monitoring Report</span>
                                                </NavLink>

                                                <NavLink to="/examschedulestatusreport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/examschedulestatusreport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsBook /></span>
                                                    <span className='leftNavIconLabel'>Exam Schedule Status</span>
                                                </NavLink>
                                            </Nav>
                                        </Accordion.Collapse>
                                    </Accordion.Item>

                                    {/* Fee Reports */}
                                    <Accordion.Item eventKey="feeReports">
                                        <Accordion.Header onClick={() => handleReportAccordionToggle("feeReports")}>
                                            <span className='leftNavIconLabel'>Fee Reports</span>
                                        </Accordion.Header>
                                        <Accordion.Collapse eventKey="feeReports">
                                            <Nav className="flex-column">
                                                <NavLink to="/feereport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/feereport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsBook /></span>
                                                    <span className='leftNavIconLabel'>Fee Report</span>
                                                </NavLink>

                                                <NavLink to="/feereceiptprintreport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/feereceiptprintreport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsBook /></span>
                                                    <span className='leftNavIconLabel'>Fee Receipt Print</span>
                                                </NavLink>

                                                <NavLink to="/studentdiscountreport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/studentdiscountreport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsBook /></span>
                                                    <span className='leftNavIconLabel'>Student Discount Report</span>
                                                </NavLink>
                                            </Nav>
                                        </Accordion.Collapse>
                                    </Accordion.Item>

                                    {/* HR & Payroll Reports */}
                                    <Accordion.Item eventKey="hrReports">
                                        <Accordion.Header onClick={() => handleReportAccordionToggle("hrReports")}>
                                            <span className='leftNavIconLabel'>HR & Payroll Reports</span>
                                        </Accordion.Header>
                                        <Accordion.Collapse eventKey="hrReports">
                                            <Nav className="flex-column">
                                                <NavLink to="/employeeattendancereport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/employeeattendancereport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><RiUserStarFill /></span>
                                                    <span className='leftNavIconLabel'>Employee Attendance Report</span>
                                                </NavLink>

                                                <NavLink to="/latedays" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/latedays') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><RiUserStarFill /></span>
                                                    <span className='leftNavIconLabel'>Employee Late Days Report</span>
                                                </NavLink>

                                                {/* When you create other HR reports, add here:
                                                <NavLink to="/payrollreport" ...>Payroll Report</NavLink>
                                                <NavLink to="/salaryreport" ...>Salary Report</NavLink>
                                                */}
                                            </Nav>
                                        </Accordion.Collapse>
                                    </Accordion.Item>
                                    {/* Generators */}
                                    <Accordion.Item eventKey="Generators">
                                        <Accordion.Header onClick={() => handleReportAccordionToggle("Generators")}>
                                            <span className='leftNavIconLabel'>Generators</span>
                                        </Accordion.Header>
                                        <Accordion.Collapse eventKey="Generators">
                                            <Nav className="flex-column">
                                                <NavLink to="/idgenerator" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/idgenerator') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsBook /></span>
                                                    <span className='leftNavIconLabel'>Id Generator</span>
                                                </NavLink>


                                                <NavLink to="/studycertificate" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/studycertificate') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsBook /></span>
                                                    <span className='leftNavIconLabel'>Study Certificate </span>
                                                </NavLink>
                                            </Nav>
                                        </Accordion.Collapse>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="UserMetrics">
                                        <Accordion.Header onClick={() => handleReportAccordionToggle("UserMetrics")}>
                                            <span className='leftNavIconLabel'>User Metrics</span>
                                        </Accordion.Header>
                                        <Accordion.Collapse eventKey="UserMetrics">
                                            <Nav className="flex-column">
                                                <NavLink to="/usermetrics" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/usermetrics') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><RiUserStarFill /></span>
                                                    <span className='leftNavIconLabel'>User Metrics</span>
                                                </NavLink>
                                            </Nav>
                                        </Accordion.Collapse>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="Financereports">
                                        <Accordion.Header onClick={() => handleReportAccordionToggle("Financereports")}>
                                            <span className='leftNavIconLabel'>Finance Reports</span>
                                        </Accordion.Header>
                                        <Accordion.Collapse eventKey="Financereports">
                                            <Nav className="flex-column">
                                                <NavLink to="/financereport" className={({ isActive }) =>
                                                    isActive || location.pathname.startsWith('/financereport') ? 'nav-link active' : 'nav-link'
                                                }>
                                                    <span className='leftNavIcon'><BsBook /></span>
                                                    <span className='leftNavIconLabel'>Finance Daily Report</span>
                                                </NavLink>



                                            </Nav>
                                        </Accordion.Collapse>
                                    </Accordion.Item>

                                </Accordion>
                            </div>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </Accordion>
                )}

                {/* Transport */}
                <Accordion activeKey={activeKey} style={{ order: isChildFutureAdmin ? 5 : undefined }}>
                    <Accordion.Item eventKey="7">
                        <Accordion.Header onClick={() => handleAccordionToggle("7")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Transport</Tooltip>}>
                                <span className='leftNavIcon'><MdOutlineEmojiTransportation /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Transport</span>
                        </Accordion.Header>
                        <Accordion.Collapse eventKey="7">
                            <Nav className="flex-column">
                                <NavLink to="/buses" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addbuses') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Vehicle Master</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Vehicle Master</span>
                                </NavLink>

                                <NavLink to="/location" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addlocation') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Route Location</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Route Location</span>
                                </NavLink>

                                <NavLink to="/routes" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addbusroutes') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Routes</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Routes</span>
                                </NavLink>

                                {/* <NavLink to="/stops" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addstops') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Stops</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Stops</span>
                                </NavLink> */}

                                <NavLink to="/busassignment" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/addbusassignment') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Bus Route Assignment</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Bus Route Assignment</span>
                                </NavLink>

                                <NavLink to="/tripattendance" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/tripattendance') ? 'nav-link active' : 'nav-link'
                                }>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Trip Attendance</Tooltip>}>
                                        <span className="leftNavIcon"><RiUserStarFill /></span>
                                    </OverlayTrigger>
                                    <span className="leftNavIconLabel">Trip Attendance</span>
                                </NavLink>
                            </Nav>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </Accordion>

                {/* Finance */}
                <Accordion activeKey={activeKey} style={{ order: isChildFutureAdmin ? 2 : undefined }}>
                    <Accordion.Item eventKey="8">
                        <Accordion.Header onClick={() => handleAccordionToggle("8")}>
                            <span className='leftNavIcon'><RiMoneyRupeeCircleFill /></span>
                            <span className='leftNavIconLabel'>Finance</span>
                        </Accordion.Header>
                        <Accordion.Collapse eventKey="8">
                            <Nav className="flex-column">
                                <NavLink to="/finance/reports" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/reports') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Finance Report</span>
                                </NavLink>
                                <NavLink to="/finance/financialyear" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/financialyear/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Financial Year Setup</span>
                                </NavLink>
                                {/* <NavLink to="/finance/chartofaccounts" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/chartofaccounts/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Chart of Accounts</span>
                                </NavLink> */}
                                <NavLink to="/finance/parent-group" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/parent-group') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Parent Group</span>
                                </NavLink>
                                <NavLink to="/finance/gmstr" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/addgmstr') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Groups</span>
                                </NavLink>


                                <NavLink to="/finance/accounthead" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/addaccounthead') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Account Head</span>
                                </NavLink>
                                <NavLink to="finance/transaction" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('finance/transaction/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Transaction Entry</span>
                                </NavLink>
                                <NavLink to="finance/subledger" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/addsubledger') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Sub Ledger Entry</span>
                                </NavLink>


                                {/* <NavLink to="/finance/account-grouptypes" className={({ isActive }) =>

                                    isActive || location.pathname.startsWith('/finance/account-grouptypes') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Account Group Type </span>
                                </NavLink>
                                <NavLink to="/finance/groups" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/groups/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Group Master</span>
                                </NavLink>

                                <NavLink to="/finance/accounts" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/accounts/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Account Master</span>
                                </NavLink>

                                <NavLink to="/finance/subaccounts" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/subaccounts/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Sub-Account Master</span>
                                </NavLink> */}

                                {/* <NavLink to="/finance/tds" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/tds/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>TDS Master</span>
                                </NavLink>

                                <NavLink to="/finance/services" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/services/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Service Master</span>
                                </NavLink>

                                <NavLink to="/finance/gste" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/gste/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>GST Master</span>
                                </NavLink> */}

                                {/* <NavLink to="/finance/gst-rate" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/gst-rate/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>GST Rate Master</span>
                                </NavLink>

                                <NavLink to="/finance/tcs" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/tcs/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>TCS Master</span>
                                </NavLink> */}

                                {/* <NavLink to="/finance/gst/mapping" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/gst/mapping/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Map Account Code</span>
                                </NavLink> */}

                                {/* <NavLink to="/finance/budget" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/budget/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Manage Budget</span>
                                </NavLink> */}

                                {/* <NavLink to="/finance/vouchers" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/vouchers/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Voucher Entry</span>
                                </NavLink> */}

                                {/* <NavLink to="/finance/voucher-approvals" className={({ isActive }) =>
                                    isActive || location.pathname.startsWith('/finance/voucher-approvals/add') ? 'nav-link active' : 'nav-link'
                                }>
                                    <span className='leftNavIconLabel'>Voucher Approval</span>
                                </NavLink> */}
                            </Nav>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </Accordion>

                {/* Asset Management */}
                {!isChildFutureAdmin && (
                    <>
                <Accordion activeKey={activeKey}>
                    <Accordion.Item eventKey="9">
                        <Accordion.Header onClick={() => handleAccordionToggle("9")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Asset Management</Tooltip>}>
                                <span className='leftNavIcon'><MdOutlineWebAsset /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Asset Management</span>
                        </Accordion.Header>
                    </Accordion.Item>
                </Accordion>

                {/* Library System */}
                <Accordion activeKey={activeKey}>
                    <Accordion.Item eventKey="11">
                        <Accordion.Header onClick={() => handleAccordionToggle("11")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>Library System</Tooltip>}>
                                <span className='leftNavIcon'><IoLibrary /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Library System</span>
                        </Accordion.Header>
                    </Accordion.Item>
                </Accordion>

                {/* LMS */}
                <Accordion activeKey={activeKey}>
                    <Accordion.Item eventKey="12">
                        <Accordion.Header onClick={() => handleAccordionToggle("12")}>
                            <OverlayTrigger placement="right" overlay={<Tooltip>LMS</Tooltip>}>
                                <span className='leftNavIcon'><MdLocalLibrary /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>LMS</span>
                        </Accordion.Header>
                    </Accordion.Item>
                </Accordion>

                {/* Study Helper */}
                <Accordion activeKey={activeKey}>
                    <Accordion.Item eventKey="15">
                        <Accordion.Header
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                navigate('/studyhelper');
                            }}
                        >
                            <OverlayTrigger placement="right" overlay={<Tooltip>Study Helper</Tooltip>}>
                                <span className='leftNavIcon'><ChatBubbleOutlineRoundedIcon /></span>
                            </OverlayTrigger>
                            <span className='leftNavIconLabel'>Study Helper</span>
                        </Accordion.Header>
                    </Accordion.Item>
                </Accordion>
                    </>
                )}

                {/* Org Visits (Only visible to Child Future Admin) */}
                {isChildFutureAdmin && (
                    <Accordion activeKey={activeKey} style={{ order: 6 }}>
                        <Accordion.Item eventKey="orgvisits">
                            <Accordion.Header onClick={() => handleAccordionToggle("orgvisits")}>
                                <OverlayTrigger placement="right" overlay={<Tooltip>Org Visits</Tooltip>}>
                                    <span className='leftNavIcon'><BsBuilding /></span>
                                </OverlayTrigger>
                                <span className='leftNavIconLabel'>Org Visits</span>
                            </Accordion.Header>
                            <Accordion.Collapse eventKey="orgvisits">
                                <Nav className="flex-column">
                                    <NavLink to="/orgvisits" className={({ isActive }) =>
                                        isActive || location.pathname.startsWith('/orgvisits') || location.pathname.startsWith('/addorgvisit') ? 'nav-link active' : 'nav-link'
                                    }>
                                        <OverlayTrigger placement="right" overlay={<Tooltip>Visits Log</Tooltip>}>
                                            <span className='leftNavIcon'><BsBuilding /></span>
                                        </OverlayTrigger>
                                        <span className='leftNavIconLabel'>Visits Log</span>
                                    </NavLink>
                                </Nav>
                            </Accordion.Collapse>
                        </Accordion.Item>
                    </Accordion>
                )}

            </Nav>
        </div>
    );
};

export default LeftNav;
